import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import moment from "moment";
import { Roles } from "../enums/Roles";

const company = store.getters.company;
let path = `company/${company.companyGuid}/sites`;
const user = store.getters.loggedInUser;
const site = store.getters.site;
const group = store.getters.group;
if(user.role === Roles.AGMSAdmin) {
  path = `company/`
}else if(user.role === Roles.PartnerAdmin) {
  path = `company/`
}else if(user.role === Roles.CompanyAdmin) {
  path = `company/${company.companyGuid}/sites`
}else if(user.role === Roles.SiteAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups`
}else if(user.role === Roles.GroupAdmin) {
  path = `company/${company.companyGuid}/sites/${site.key}/groups/${group.key}/computers`
}

const data = {
  readyToUseFilters: {},
  filter: {
    ignoreSaveFilter: true,
    searchText: true,
    title: "newcomfilter",
    pageName: "ComputerPageFilter",
    genre: "computerPageFilter",
    filters: [
      {
        title: "companySiteGroup",
        type: "siteAndGroup",
        vmodel: "",
        apiEquivalent: "groupGuids",
        param: "name",
        data: [],
      },
      {
        title: "computer",
        type: "computer",
        vmodel: "",
        apiEquivalent: "computer",
        param: "name",
        data: [],
      },
      {
        title: "protectionStatus",
        type: "select",
        param: "protectionStatusFilter",
        vmodel: "",
        apiEquivalent: "protectionStatusFilter",
        placeholder: "Select Protection Status",
        data: [
          {
            id: "Unknown",
            protectionStatusFilter: "Unknown",
          },
          {
            id: "Protection On, TamperGuard On",
            protectionStatusFilter: "Protection On, TamperGuard On",
          },
          {
            id: "Protection Off, TamperGuard Off",
            protectionStatusFilter: "Protection Off, TamperGuard Off",
          },
          {
            id: "Protection Off",
            protectionStatusFilter: "Protection Off",
          },
          {
            id: "TamperGuard Off",
            protectionStatusFilter: "TamperGuard Off",
          },
          {
            id: "Global Discovery On",
            protectionStatusFilter: "Global Discovery On",
          }
        ],
      },
    ],
  },
  header: {
    navigation: [
      {
        title: "endpoints",
        icon: "drak_computer",
        url: "computers/all",
      },
      {
        title: "browseassets",
        icon: "breadcrumb",
        url: path,
      },
      {
        title: "usersbycomputer",
        icon: "group",
        active: true,
        url: "users-by-computers",
      },
    ],
    buttonPosition: "pr-4 justify-content-between",
    buttons: [],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "user",
          field: "userName",
          excelField: "user",
          sortable: true,
          display: function (row: any) {
            if (row.userName) {
              return row.userName
            }else {
              return 'N/A';
            }
          },
        },
        {
          label: "computername",
          field: "computerName",
          sortable: true,
          components: [
            {
              // component: "rowRouter",
              // key: "computerName",
              // route: function (row: any) {
              //   const url = `/assets/company/${row.companySiteGroupInfo.companyGuid}/sites/${row.companySiteGroupInfo.siteGuid}/groups/${row.companySiteGroupInfo.groupGuid}/computers/${row.ComputerId}`;
              //   return url;
              // },
              // displayField: "computerName",
              component: "tableModalComponent",
              label: "computer",
              sortable:"true",
              width:"120px",
              field: "computerName",
              truncate: {
                position: "middle",
                first: 6,
                last: 6,
                show: function (row: any) {
                  return (
                    "<div><p><strong>Computer Name: </strong>" +
                    row.computerName
                  );
                },
              },
              selectedTab: "ag-tab_computer"
            },
          ],
        },
        // {
        //   label: "Site",
        //   display: function (row: { companySiteGroupInfo: { siteName: any } }) {
        //     const siteName = `${row.companySiteGroupInfo}`;
        //     return `<div class="multi-line"><div class="line">${siteName}</div> <div class="line">${siteName}</div></div>`;
        //   },
        // },
        // {
        //   label: "Group",
        //   display: function (row: {
        //     companySiteGroupInfo: { groupName: any };
        //   }) {
        //     const groupName = `${row.companySiteGroupInfo}`;
        //     return groupName;
        //   },
        // },
        {
          label: "firstreported",
          field: "firstSeen",
          excelField: "firstSeen",
          sortable: false,
          display: function (row: { firstSeen: moment.MomentInput }) {
            if (row.firstSeen)
              return moment(row.firstSeen).format("DD/MM/YYYY HH:MM");
            else return "";
          },
        },
        {
          label: "lastreported",
          field: "lastSeen",
          sortable: true,
          excelField: "lastSeen",
          components: [
            {
              component: "tableDateFormatter",
              field: "lastSeen",
            },
          ],
        },
        {
          label: "protectionStatus",
          field: "lastProtectionStatus",
          excelField: "lastProtectionStatus",
          sortable: false,
        },
      ],
      rows: [],
      total: 0,
      sortable: {
        order: "name",
        sort: "asc",
      },
      page: 0,
      pageSize: 10,
      isLoading: true,
      dateFilter: false,
      fetchTable: async (options: any) => {
        const filters = data.readyToUseFilters;
        const body = { filters, options };
        store.dispatch(GeneralActionTypes.GET_COMPUTER_LIST_BY_USER, body);
      },
    },
  },
  modals: [
    {
      id: "exampleModalCenter",
      action: {
        label: "OK",
        function: function (arg: any) {
          alert(JSON.stringify(arg));
        },
      },
      cancel: {
        label: "Close",
      },
      active: 0,
      items: [
        {
          title: "computer",
          component: "ag-computer",
        }
      ],
    },
  ],
};

export default data;
